var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list-cell', {
    staticClass: "uk-margin-remove",
    attrs: {
      "items": _vm.attachments,
      "type": "bullet"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(document) {
        return [_c('a', {
          attrs: {
            "href": document.item.url,
            "target": "_blank"
          }
        }, [_c('attachment-name', {
          attrs: {
            "attachment": document.item
          }
        })], 1)]
      }
    }])
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8b9cb62","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/DocumentsCell.vue
// module id = 2118
// module chunks = 0